<template>
  <loader v-if="loading" :active="loading" />
  <leaflet
    v-else-if="isVisible"
    :computed-read-only="computedReadOnly"
    :map-props="mapProperties"
    :field="field"
    @map-changed="onMapChanged($event)"
  />
</template>

<script>
import Loader from '../../../components/Loader'
import formstore from '../../../utils/mixin-formstore'
import Leaflet from '../../../components/leaflet/Leaflet'
import leafletMixin from '../../../utils/mixin-leaflet'
import { get, isEmpty } from 'lodash'

/**
 * @class LeafletControlStore
 *
 * @description This component is the state handler for Leaflet - MAP form field
 */
export default {
  name: 'LeafletControlStore',
  components: {
    Leaflet,
    Loader,
  },
  mixins: [formstore, leafletMixin],
  props: ['path', 'groupReadOnly'],
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    await this.getData()
  },
  computed: {
    computedReadOnly() {
      return Boolean(this.readOnly || this.groupReadOnly)
    },
    mapProperties() {
      let mapProperties
      try {
        mapProperties = JSON.parse(get(this.field, 'mapProperties', '{}'))
      } catch {
        mapProperties = {}
      }
      return mapProperties
    },
    isVisible() {
      return !this.hidden
    },
    mapDataEntity() {
      return this.field.mapDataEntity
    },
    formId: {
      get() {
        return this.$get('form').id
      },
    },
    fieldName: {
      get() {
        return this.name
      },
    },
  },
  methods: {
    onMapChanged($event) {
      $event.onMounted
        ? this.$dispatch('updatePropByPath', {
            path: this.path,
            prop: 'value',
            value: $event.payload,
            byExpression: true,
            formName: this.formName,
          })
        : (this.value = $event.payload)
    },
    async getData() {
      if (this.formId && this.name) {
        const { data } = await this.$client.execute({
          operationId: 'Map_getData',
          parameters: {
            idForm: this.formId,
            itemName: this.name,
          },
        })

        if (data) {
          Object.assign(this.mapProperties, JSON.parse(data))
        }
      }

      if (this.mapDataEntity && !isEmpty(this.mapDataEntity)) {
        const mapOverlays = await this.$client.execute({
          operationId: 'Map_getLayerData',
          parameters: {
            idForms: JSON.stringify(this.mapDataEntity.map(({ value }) => value)),
          },
        })

        const overLays = JSON.parse(get(mapOverlays, 'data', '[]'))
        Object.assign(this.mapProperties.overlays, this.resolveOverlayParams(overLays))
      }

      this.loading = false
      if (this.$refs.map) this.$refs.map.removeAttribute('hidden')
    },
  },
}
</script>
